import { TopSponsoredProduct } from '@/productDiscovery/SponsoredProducts/interfaces/TopSponsoredProduct';

import type { Product } from '../algolia/interfaces/product';
import type { Facets, FacetsStats } from './facets/interfaces/facets';
import type { StoreError } from './interfaces/error';
import type { FilterConfig } from './interfaces/filterConfig';
import type { CategoriesList } from './technicalFilters/utils/generateTechnicalFiltersQuery';

export const initialState: ListingState = {
  pageName: null,
  fetchingAlgolia: false,
  products: [],
  facets: {},
  customFacets: {},
  inspectListings: false,
};

export type ListingPage =
  | 'search'
  | 'massLanding'
  | 'commercialOperationListing'
  | 'category'
  | 'brand'
  | 'goodDeals';

export type ListingState = TypedListingState<Product>;

export interface TypedListingState<P extends Product = Product> {
  pageName: ListingPage | null;
  fetchingAlgolia: boolean;
  error?: StoreError;
  products?: P[];
  nbHits?: number;
  nbProducts?: number;
  page?: number;
  nbPages?: number;
  productsPerPage?: number;
  facets?: Facets;
  facetsStats?: FacetsStats;
  customFacets?: Facets;
  url?: string;
  index?: string;
  queryID?: string | null;
  filtersConfig?: FilterConfig[];
  rerankingCount?: number;
  searchEngineProxy?: boolean;
  ruleContexts?: string[];
  categoriesList?: CategoriesList;
  displayToaster?: boolean;
  topSponsoredProduct?: TopSponsoredProduct;
  inspectListings?: boolean;
}

export interface ProcessedFacets {
  facets: Facets;
  facetsStats: FacetsStats;
  customFacets: Facets;
}

export interface ProcessedResult<P extends Product = Product> {
  products: P[];
  nbHits?: number;
  nbProducts: number;
  page: number;
  nbPages: number;
  productsPerPage: number;
  facets: Facets;
  customFacets: Facets;
  facetsStats: FacetsStats;
  index: string;
  queryID: string | null;
}
